import { ComponentProps, useEffect, useState } from 'react';
import { ShoutoutCard } from 'components/shoutout-card';
import { motion } from 'framer-motion';
import { AnimationItem } from 'lottie-web';
import { useLiveDisplayCampaign } from 'queries/livedisplay';

interface ShoutoutProps {
  slug: string;
  lottieNewDonation: AnimationItem | null;
}

const Shoutout = (props: ShoutoutProps) => {
  const { slug: campaignSlug, lottieNewDonation } = props;
  const { data = { spaces: [] } } = useLiveDisplayCampaign({
    campaignSlug,
  });
  const spaces = data.spaces;
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(c => c + 1);
  }, [data]);

  useEffect(() => {
    if (lottieNewDonation != null) {
      lottieNewDonation.play();
    }
  }, [data, lottieNewDonation]);

  if (spaces.length > 0) {
    return (
      <div className={`flex h-full flex-col justify-between`}>
        <div
          key={count}
          className={'flex flex-col justify-between overflow-hidden px-4 pt-4 xl:px-8 xl:pt-10'}
        >
          {spaces.map((shoutout, i) => {
            const isFirst = i === 0;

            const isFirstMotionProps: ComponentProps<typeof motion.div> = isFirst
              ? {
                  animate: { x: 0 },
                  initial: { x: 500 },
                  transition: { duration: 1 },
                }
              : {
                  animate: { y: 0 },
                  initial: { y: -206 },
                  transition: { duration: 1 },
                };

            return (
              <motion.div
                key={shoutout.id}
                {...isFirstMotionProps}
                className={`mb-7 last-of-type:mb-0 2xl:mb-8`}
              >
                <ShoutoutCard shoutout={shoutout} />
              </motion.div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex h-full flex-col justify-between`}>
      <div className={'mt-8 text-center text-2xl font-bold'}>Be the first to support!</div>
    </div>
  );
};

export { Shoutout };
